import { Typography } from "@mui/material";
import { TypographyProps } from "../types/prop-types";

const Title = ({ sx, center, children, color = "" }: TypographyProps) => (
  <Typography
    variant="h4"
    sx={{ mb: "1%", ...sx, textAlign: center ? "center" : "unset" }}
    color={color}
  >
    {children}
  </Typography>
);
export default Title;
